<div class="close-overlay" (click)="close()"></div>

<div class="sheet-container" #sheetContainer>
    <div class="sheet-handle-container" (click)="close()" (panstart)="onPanStart($event)" (panmove)="onPanMove($event)" (panend)="onPanEnd($event)">
        <div class="grabber"></div>
    </div>
    
    <div class="sheet-content">
        @if (loading) {
            <div class="horizinns-container center">
              <app-loader></app-loader>
            </div>
          } @else if (property) {
            <div class="property-view-container">
                <app-property-card [property]="property"></app-property-card>
            </div>
          }
      </div>
</div>